// extracted by mini-css-extract-plugin
export default {"topic_user":"Topics_topic_user__yNPv1"};